export default "__VITE_ASSET__c18d17ea__"